import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeature } from 'bv-hooks';
import { zendesk } from 'bv-services';
import { v as bvVar } from 'bv';

export default () => {
  const { proactiveTriggers } = bvVar('zendeskConfig');
  const isWidgetBooted = () => !!window.zE || !!window.zChat;
  const { pathname } = useLocation();
  const zendekLoaderEnabled = useFeature('zendesk_proactive_chats');

  useEffect(() => {
    if (
      !zendekLoaderEnabled
      || !proactiveTriggers?.length
      || isWidgetBooted()
    ) {
      return;
    }

    const zendeskTrigger = proactiveTriggers.find((path) => path === pathname);

    if (!zendeskTrigger) {
      return;
    }

    zendesk.liveChat({ keepHidden: true });
  }, [pathname]);
};
